import { PlusOutlined } from '@ant-design/icons'
import { Component } from 'react'
import { Link as RLink } from 'react-router-dom'

export default class AddLink extends Component {
  render() {
    return (
      <RLink
        to={this.props.to}
        style={this.props.style}
        className={`btn link ${this.props.className}`}>
        <PlusOutlined /> {this.props.children}
      </RLink>
    )
  }
}
